import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import ProductList from "../ProductList";
import ErrorAlert from "../../containers/ErrorAlert";
import SmallScreenHeader from "../../containers/SmallScreenHeader";
import MediumLargeScreenHeader from "../../containers/MediumLargeScreenHeader";
import LayoutManagerContainer from "../../containers/LayoutManager";
import SearchTerm from "../SearchTerm";
import styles from "./ProductListingPage.css";
import RenderToggle from "../RenderToggle";
import CategoryRefinementLinks from "../CategoryRefinementLinks";

const styleContext = classNames.bind(styles);

export const ProductListingPage = props => {
  const {
    hasFacets,
    isNewSearch,
    location: { search },
    error
  } = props;
  const queryStringRef = useRef(search);
  const { current: queryString } = queryStringRef;

  useEffect(() => {
    if (!!error || queryString !== search) {
      queryStringRef.current = search;

      if (isNewSearch) {
        window.scrollTo(0, 0);
      }
    }
  }, [error, search]);

  return (
    <div
      className={styleContext({
        container: true,
        wrapper: hasFacets
      })}
    >
      <LayoutManagerContainer />
      <SearchTerm />
      <RenderToggle isToRender={hasFacets}>
        <>
          <SmallScreenHeader />
          <MediumLargeScreenHeader />
        </>
      </RenderToggle>
      <ProductList {...props} />
      <CategoryRefinementLinks />
      <ErrorAlert />
    </div>
  );
};

ProductListingPage.propTypes = {
  isNewSearch: PropTypes.bool,
  location: PropTypes.object.isRequired,
  error: PropTypes.object,
  hasFacets: PropTypes.bool.isRequired
};

export default ProductListingPage;
